import { Component, OnInit, Input } from '@angular/core';
import { ConcentreComponent } from './concentre/concentre.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { RelatoComponent } from './relato/relato.component';
import { ConcentreLegadoComponent } from './concentre-legado/concentre-legado.component';
import { RelatoLegadoComponent } from './relato-legado/relato-legado.component';
import { CrednetComponent } from './crednet/crednet.component';
import { SerasaService } from '../../service/serasa.service';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-serasa',
  templateUrl: './serasa.component.html',
  styleUrls: ['./serasa.component.scss'],
  providers: [SerasaService]
})
export class SerasaComponent implements OnInit {
        
  @Input("userID") userID;
  @Input("serasaObj") serasaObj;
  private serasaList; 
  private resultCountSerasa;
  private currentPage = 0;

  constructor(private dialogService: DialogService,
              private serasaService: SerasaService,
              private flashMessagesService: FlashMessagesService) { }
 

  ngOnInit() {
    this.getSerasaHistory();
  }

  getSerasaHistory(){
    this.serasaService.getSerasaHistory(this.userID, this.currentPage).subscribe(result =>{
      if (result.Result){
        this.serasaList = result.Result;
        this.resultCountSerasa = result.Count;
        console.log(this.resultCountSerasa);
        console.log(result);
      }else{
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
        console.log(result);
    }
  }, error => {
      this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
    });
  }


  showModal(type, serasaObj){
    if (type == 1){
    this.dialogService.addDialog(ConcentreComponent, {serasaObj: serasaObj}, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
    }

    if (type == 2){
      this.dialogService.addDialog(CrednetComponent, {serasaObj: serasaObj}, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
    }

    if (type == 3){
      this.dialogService.addDialog(RelatoComponent, {serasaObj: serasaObj}, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
    }
  }

  onSelectSerasa(serasaID, tipoSerasa){
    this.serasaService.requestSerasaByID(serasaID).subscribe(result => {
      if (!result || !result.Success || !result.Result) {
        this.flashMessagesService.show(
          (result && result.Errors) ? result.Errors : 'Não foi possível carregar o histórico Serasa.',
          { cssClass: 'alert-danger', timeout: 6000 }
        );
        return;
      }

      const data = result.Result;

      // Formato REST InfoMais (PF)
      if (data.Registration || data.NegativeData) {
        this.showModal(1, data);
        return;
      }

      // Formato REST InfoMais (PJ)
      if (data.Company || data.NegativeAnnotations) {
        this.showModal(3, data);
        return;
      }

      // Legado Concentre (PF) — ReturnConcentre
      if (data.NomeCliente || data.DocumentoCliente) {
        this.dialogService.addDialog(ConcentreLegadoComponent, { serasaObj: data }, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
        return;
      }

      // Legado Relato (PJ) — ReturnRelato
      if (data.RazaoSocial || data.CNPJ) {
        this.dialogService.addDialog(RelatoLegadoComponent, { serasaObj: data }, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
        return;
      }

      this.flashMessagesService.show(
        'Não foi possível identificar o formato deste registro Serasa.',
        { cssClass: 'alert-warning', timeout: 8000 }
      );
    }, error => {
      this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
    });
  }


  paginar($event, type) {
			this.currentPage = $event;
			this.getSerasaHistory();
		}
}



// WEBPACK FOOTER //
// ./src/app/serasa/component/serasa/serasa.component.ts